import { useState } from "react";
import axios from "axios";

const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://realtimechat-07z5.onrender.com" // Same Render URL as App.js
    : "http://localhost:3001";

function Auth({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isRegistering, setIsRegistering] = useState(false); // Toggle between Login/Register
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); // Clear previous errors

    const endpoint = isRegistering ? "register" : "login";

    try {
      const response = await axios.post(`${API_URL}/${endpoint}`, {
        username,
        password,
      });

      if (isRegistering) {
        // If registered successfully, switch to login mode automatically
        alert("Registration Successful! Please Login.");
        setIsRegistering(false);
      } else {
        // If login successful, tell the parent App component
        onLogin(response.data.username);
      }
    } catch (err) {
      setError(err.response?.data?.message || "An error occurred");
    }
  };

  return (
    <div className="joinChatContainer">
      <h3>{isRegistering ? "Register" : "Login"}</h3>

      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          alignItems: "center",
        }}
      >
        <input
          type="text"
          placeholder="Username..."
          onChange={(event) => setUsername(event.target.value)}
        />
        <input
          type="password"
          placeholder="Password..."
          onChange={(event) => setPassword(event.target.value)}
        />

        {error && (
          <p
            style={{
              color: "var(--danger)",
              fontSize: "12px",
              marginTop: "5px",
            }}
          >
            {error}
          </p>
        )}

        <button type="submit">{isRegistering ? "Sign Up" : "Sign In"}</button>
      </form>

      <p
        style={{
          marginTop: "10px",
          fontSize: "12px",
          cursor: "pointer",
          color: "var(--text-muted)",
        }}
        onClick={() => setIsRegistering(!isRegistering)}
      >
        {isRegistering
          ? "Already have an account? Login"
          : "Don't have an account? Register"}
      </p>
    </div>
  );
}

export default Auth;
